import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

export enum SpotlightLayout {
  LeftAlternating = 'leftAlternating',
  RightAlternating = 'rightAlternating',
  LeftAll = 'leftAll',
  RightAll = 'rightAll',
}

const SpotlightLayoutSchema = z.nativeEnum(SpotlightLayout);

const SpotlightStyleSchema = z.object({
  backgroundColor: z.string(),
});

const SpotlightOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  layout: SpotlightLayoutSchema.optional(),
  preheaderEnabled: z.boolean().optional(),
  style: SpotlightStyleSchema.optional(),
  subheaderEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
});

const SpotlightHeaderSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const SpotlightPreheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const SpotlightSubheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});
const SpotlightFeatureHeaderSchema = RichTextFieldSchema.extend({
  name: z.literal('featureHeader'),
  role: z.literal(FieldRole.Header),
});

const SpotlightFeatureSubheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('featureSubheader'),
  role: z.literal(FieldRole.Subheader),
});

const SpotlightFeatureImageSchema = ImageFieldSchema.extend({
  name: z.literal('featureImage'),
  role: z.literal(FieldRole.Image),
});

const SpotlightFieldSchema = z.discriminatedUnion('name', [
  SpotlightHeaderSchema,
  SpotlightPreheaderSchema,
  SpotlightSubheaderSchema,
]);

const FeatureFieldSchema = z.discriminatedUnion('name', [
  SpotlightFeatureHeaderSchema,
  SpotlightFeatureSubheaderSchema,
  SpotlightFeatureImageSchema,
]);

const SpotlightFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(SpotlightFieldSchema),
});

const FeatureFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FeatureFieldSchema),
});

export const SpotlightBlockConfigSchema = z.object({
  options: SpotlightOptionsSchema,
  type: z.literal(BlockType.Spotlight),
  fieldGroups: z.tuple([SpotlightFieldGroupSchema]).rest(FeatureFieldGroupSchema),
  version: z.literal(1),
});
